import { ConnectorInfo } from '@blaze-shared/api-contracts-domain';
import { BaseSchema } from '@blaze-shared/schema-domain';
import { PrintToPdfWorkflowNode } from '@blaze-shared/workflow-domain';

import { NAME_SOURCE_ID } from '../../errors';
import {
  getColumnReferencesFromString,
  getNamedInputReferencesFromString,
  getParamReferencesFromString,
  getTagReferencesFromString,
} from '../../references/get-references-from-string';
import {
  WorkflowNodeColumnReference,
  WorkflowNodeNamedInputReference,
  WorkflowNodeParamReference,
  WorkflowNodeTagReference,
} from '../../references/references.models';
import { BaseWorkflowNode, WorkflowNode } from '../../registry/node.registry';

// The header/footer HTML is intentionally NOT scanned for references — the PDF
// service uses it verbatim, so $$-style references are not supported there.
@WorkflowNode('PrintToPdf')
export class PrintToPdfNode extends BaseWorkflowNode<PrintToPdfWorkflowNode> {
  static readonly FILE_NAME_SOURCE_ID = NAME_SOURCE_ID;

  getColumnReferences(schemas: Map<string | symbol, BaseSchema>): WorkflowNodeColumnReference[] {
    return getColumnReferencesFromString(
      this.node.fileName,
      schemas,
      PrintToPdfNode.FILE_NAME_SOURCE_ID,
    );
  }

  getTagReferences(schemas: Map<string | symbol, BaseSchema>): WorkflowNodeTagReference[] {
    return getTagReferencesFromString(
      this.node.fileName,
      schemas,
      PrintToPdfNode.FILE_NAME_SOURCE_ID,
    );
  }

  getParamReferences(
    schemas: Map<string | symbol, BaseSchema>,
    connectors: ConnectorInfo[],
  ): WorkflowNodeParamReference[] {
    return getParamReferencesFromString(
      this.node.fileName,
      schemas,
      connectors,
      PrintToPdfNode.FILE_NAME_SOURCE_ID,
    );
  }

  getNamedInputReferences(
    schemas: Map<string | symbol, BaseSchema>,
  ): WorkflowNodeNamedInputReference[] {
    return getNamedInputReferencesFromString(
      this.node.fileName,
      schemas,
      PrintToPdfNode.FILE_NAME_SOURCE_ID,
    );
  }
}
